// extracted by mini-css-extract-plugin
export default {"subjects":"subjects_subjects__uelOg","title":"subjects_title__qtiWm"};